export default __webpack_public_path__ + "static/media/addvideoImge.8b0af7d7.png";